// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import { UseLocalMessageType } from '@Helpers/locale';
import { getValidRulePassword } from '@Helpers/password';
import React, { ReactElement } from 'react';

import './RulesPassword.scss';

interface RulesViewerPasswordProps {
    rules: Record<string, any>;
    error: string[];
    local: UseLocalMessageType;
    className?: string;
    active?: boolean;
}

export const RulesViewerPassword = ({
    rules,
    local,
    error,
    active = false,
    className,
}: RulesViewerPasswordProps): ReactElement => {
    return (
        <div className={classList('rule-viewer-password', className, { active })}>
            <ul className="rule-viewer-password__list">
                {getValidRulePassword(rules, local, error).map(({ text, error }, index) => (
                    <li key={index} className={classList('rule-viewer-password__item', { error })}>
                        {text}
                    </li>
                ))}
            </ul>
        </div>
    );
};
